export default __webpack_public_path__ + "a51f7bf8c930465616e0e96a307b6d7f.png";